import { render } from "./Detail.vue?vue&type=template&id=117f87fe&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=117f87fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-117f87fe"

export default script